<template>
  <div :class="[isLargeScreen?'login':'loginMobile']">
    <div class="nav">
      <div class="nav-inner-pannel">
        <div class="logo">
          <img :src="commenUrl+platInfo.logo" v-if="platInfo.logo">
        </div>
        <div class="back-home"><router-link to="/">首页</router-link></div>
      </div>
    </div>
    <div class="main">
      <div class="form-wrap" :style="{'margin-top':marT+'vw'}">
          <div class="form-panel" v-if="loginWay=='0'">
            <div class="login-way-tab">
              <div class="current-tit">
                <div class="txt">账号密码登录</div>
                <div class="line"></div>
              </div>
              <a class="btn-tit" href="javascript:;" @click="loginWay='1'">短信快捷登录 <span v-if="isLargeScreen">></span></a>
            </div>
            <el-form :model="userPsdForm" ref="ruleFormRef" :rules="rules">
              <el-form-item prop="username">
                <div class="zdy-label" v-if="isLargeScreen">
                  <div class="zdy-label-inner">用户名</div>
                </div>
                <el-input
                  v-model="userPsdForm.username"
                  placeholder="请输入用户名"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <div class="zdy-label" v-if="isLargeScreen">
                  <div class="zdy-label-inner">登录密码</div>
                </div>
                <el-input
                  v-model="userPsdForm.password"
                  placeholder="请输入登录密码"
                  type="password"
                  clearable
                >
                </el-input>
              </el-form-item>
              <div class="remeber-password" v-if="!isLargeScreen">
                <el-checkbox v-model="isRemember" size="small">记住密码</el-checkbox>
              </div>
              <el-button
                type="primary"
                class="login-sub-btn"
                :loading="loading"
                @click="submitForm(ruleFormRef)"
                ><span>登录</span></el-button>
              <div class="remeber-password" v-if="isLargeScreen">
                <el-checkbox v-model="isRemember" size="small">记住密码</el-checkbox>
                <!-- <a href="javascript:;">忘记密码？</a> -->
              </div>
            </el-form>
          </div>
          <div class="form-panel" v-else>
            <div class="login-way-tab">
              <div class="current-tit">
                <div class="txt">短信快捷登录</div>
                <div class="line"></div>
              </div>
              <a class="btn-tit" href="javascript:;" @click="loginWay='0'">账号密码登录 <span v-if="isLargeScreen">></span></a>
            </div>
            <el-form :model="mobileCodeForm" :rules="mobileCodeRules" ref="mobileCodeRef">
              <el-form-item prop="mobile">
                <el-input 
                  v-model="mobileCodeForm.mobile"
                  placeholder="请输入注册手机号或邮箱"
                  clearable>
                  <template #prefix v-if="isLargeScreen">
                    <span class="iconfont">&#xe622;</span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="valCode">
                <div class="val-code-wrap">
                  <el-input 
                    v-model="mobileCodeForm.valCode"
                    placeholder="请输入验证码">
                    <template #prefix v-if="isLargeScreen">
                      <span class="iconfont">&#xe621;</span>
                    </template>
                  </el-input>
                  <div v-if="isLargeScreen">
                    <el-button type="primary" @click="getValCode(mobileCodeForm.mobile)" v-if="!countdownFlag">{{ codeBtnText }}</el-button>
                    <el-button type="primary" v-else disabled>{{ countdown }}</el-button>
                  </div>
                  <div v-else class="code-btn">
                    <span @click="getValCode(mobileCodeForm.mobile)" v-if="!countdownFlag">{{ codeBtnText }}</span>
                    <span v-else>{{ countdown }}</span>
                  </div>
                </div>
              </el-form-item>
              <el-button
              type="primary"
              :loading="loading"
              @click="submitForm(mobileCodeRef)"
              class="login-sub-btn"
              >登录</el-button>
            </el-form>
          </div>
          <div class="go-register-panel">
            <div><span>还没账号？</span><a href="javascript:;" @click="jumper">立即注册</a></div>
          </div>
        </div>
    </div>
    <div class="footer" ref="footerRef">
      <div class="footer-inner-pannel">
        <!-- <div><span>鲁ICP备2024099623号</span><span>公安备案</span><span>增值电信业务经营许可证</span><span>营业执照</span><span>食品经营许可证</span></div>
        <div><span>潍坊农业开发发展集团有限公司(版权所有)</span><span>齐民商通科技服务有限公司(运营公司)</span><span>北京新盟风控科技有限公司(技术公司)</span><span>客服电话：0536-7267526</span></div>
        <div class="float-r"><span>法律声明</span><span>隐私政策声明</span></div> -->
        <Footer :platInfo="platInfo"></Footer>
      </div>
    </div>
    
    </div>
</template>
<script setup>
import { getCurrentInstance, reactive, ref,onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import Md5 from "js-md5";
import Footer from '../components/footerZz.vue'
let Base64 = require("js-base64").Base64;
const { proxy } = getCurrentInstance();

// 1. 定义一个响应式变量来存储窗口宽度
const windowWidth = ref(window.innerWidth);

// 2. 定义一个方法来更新窗口宽度
const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

// 3. 使用 computed 属性来判断屏幕大小
//    这里以 768px 为分界线，你可以根据需求修改
const isLargeScreen = computed(() => {
  return windowWidth.value >= 768;
});




const props = defineProps({
    platInfo: {
        type: Object,
        default: {}
    }
})
const router = useRouter();
const route=useRoute();
let userPsdForm=reactive({});
let rules = reactive({
  username: [{ required: true, message:"请输入用户名", trigger: "blur" }],
  password: [{ required: true, message:"请输入登录密码", trigger: "blur" }],
});
let loginWay=ref("0")
let mobileCodeForm=reactive({});
let mobileCodeRules=reactive({
  mobile: [
    { required: true, message:"请输入手机号或邮箱", trigger: "blur" },
  ],
  valCode: [{ required: true, message:"请输入验证码", trigger: "blur" }],
})

let loading=ref(false);
const ruleFormRef=ref();
const mobileCodeRef=ref();
function submitForm(formEl){
  formEl.validate((valid) => {
    if (!valid) return false;
    loading.value = true;
    if (loginWay.value == "0") {
      userPsdLogin();
    } else {
      mobileCodeLogin();
    }
  });
}
function userPsdLogin(loginUrl) {
  var password ="",basic ="",loginUrl="MASTER_LOGIN";
  password = Md5(userPsdForm.password);
  basic = "Basic " + Base64.encode(userPsdForm.username + ":" + password);
  proxy.$request({
    url: loginUrl,
    method: "post", //可以不传method 默认是post请求，
    xhrFields: { withCredentials: true },// 允许携带证书
    headers: { Authorization: basic },
  }).then((res) => {
    if (res.data.code == "000") {
      successLogin(res);
    }
    loading.value = false;
  }).catch((err) => {
    loading.value = false;
    console.log(err);
  });
}

function checkauthstate() {
  proxy.$request({
    url: "W_MEMB_FINDENTPMEMBINFO",
    method: "post",
  }).then((res) => {
    if (res.data.code == "000") {
      let routerFrom=router.options.history.state.back;
      if(routerFrom&&routerFrom!='/register'){
        if(route.query.toPath){
          router.push({
            path:route.query.toPath,
          });
        }else{
          router.go(-1);
        }
      }else{
        router.push("/")
      }
    }
  }).catch((err) => {
    console.log(err);
  });
}

function getQueryParam(param) {//获取地址拦指定参数值
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
}
let isRemember=ref(false);
function successLogin(res) {
  //登录成功后处理
  proxy.setCookie("userInfoB2B", JSON.stringify(res.data.result));
  proxy.setCookie("membIdB2B", res.data.result.user.id);
  proxy.setSharedCookie("userInfoB2B", JSON.stringify(res.data.result))
  proxy.setSharedCookie("membIdB2B", res.data.result.user.id)
  setCookie("wbf_access_token",res.data.result.accessToken,1);
  if(loginWay.value=='0'){
    if (isRemember.value) {
      localStorage.setItem("sznc_WebsiteUsername", userPsdForm.username);
      localStorage.setItem("sznc_WebsitePassword", userPsdForm.password);
    } else {
      // localStorage.setItem("sznc_WebsiteUsername", "");
      localStorage.setItem("sznc_WebsitePassword", "");
    }
  }
  console.log(getQueryParam("redirect_url"))
  if(getQueryParam("redirect_url")){
    // 动态创建 a 标签 
    const link = document.createElement('a');
    link.href = getQueryParam("redirect_url");  // 设置目标 URL 
    document.body.appendChild(link);
    link.click();
    
  }
  checkauthstate()
}
function init() {
  userPsdForm.username = localStorage.getItem("sznc_WebsiteUsername")
    ? localStorage.getItem("sznc_WebsiteUsername")
    : "";
  userPsdForm.password = localStorage.getItem("sznc_WebsitePassword")
    ? localStorage.getItem("sznc_WebsitePassword")
    : "";
  if (userPsdForm.password) {
    isRemember.value = true;
  }
  proxy.setCookie("userInfoB2B","");
  proxy.setCookie("membIdB2B","");

  proxy.setSharedCookie("userInfoB2B","")
  proxy.setSharedCookie("membIdB2B","")
  // proxy.$request({
  //   url: "W_PERSON_GET",
  //   method: "post",
  // }).then((res) => {
   
  // }).catch((err) => {
  //   console.log(err);
  //   // if(err.code=="901"){
  //   //   console.log('清除缓存')
  //   //   proxy.setCookie("userInfoB2B","");
  //   //   proxy.setCookie("membIdB2B","");
  //   // }
  // });
}
init();
function mobileCodeLogin() {
  proxy.$request({
    url: "MOBILE_MOBILEOREMAILLOGIN",
    method: "post",
    data: {
      mobileOrEmail: mobileCodeForm.mobile,
      valCode: mobileCodeForm.valCode,
    },
  }).then((res) => {
    if (res.data.code == "000") {
      successLogin(res);
    }
    loading.value = false;
  }).catch((err) => {
    loading.value = false;
    console.log(err);
  });
}
function getValCode(mobile) {
  //获取手机验证码
  if (!mobile) {
    proxy.$message.warning("请输入手机号码或邮箱");
    return
  }
  proxy.$request({
    method: "post",
    url: "SYSTEM_MOBILE_VALCODE_SEND",
    data: {
      mobile: mobile,
      platType: "2",
    },
  }).then((res) => {
    if (res.data.code == "000") {
      proxy.$message({
        type: "success",
        message:"验证码已发送！",
      });
    }
  });
  setTime();
}
let codeBtnText=ref("获取验证码")
let countdown=ref("");
let countdownFlag=ref(false);
let sendTimer=ref(null);
function setTime() {
  //设置倒计时方法
  var time = 60;
  countdown.value = time + "秒后重新发送";
  countdownFlag.value = true;
  clearInterval(sendTimer.value);
  sendTimer.value = setInterval(() => {
    time--;
    let time0=""+time;
    if(time<10){
      time0="0"+time
    }
    countdown.value = time0 + "秒后重新发送"
    if (time < 1) {
      clearInterval(sendTimer.value);
      time = 60;
      codeBtnText.value = "重发验证码"
      countdownFlag.value = false;
    }
  }, 1000);
}
function jumper() {
  let url=router.resolve({
    path: "register",
  })
  proxy.tool.openWindow(url.href,'_blank');
}
const footerRef=ref();
const marT=ref(0);
// 4. 组件挂载时：添加 resize 事件监听器
onMounted(() => {
  if(isLargeScreen.value){
    const footerH=footerRef.value.clientHeight;
    const footerHvw=(footerH/1920*100)/2
    marT.value=-(13+footerHvw);
  }
  
  window.addEventListener('resize', updateWidth);
});

// 5. 组件卸载时：移除 resize 事件监听器，防止内存泄漏
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});
</script>

<style lang="less">
.login{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;@font-face {
  font-family: 'iconfont';  /* Project id 5011108 */
    src: url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.woff2?t=1756705900704') format('woff2'),
        url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.woff?t=1756705900704') format('woff'),
        url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.ttf?t=1756705900704') format('truetype');
  }
  position: relative;
  .iconfont{
    font-family: 'iconfont'; 
  }
  .nav{
    width: 100%;
    height: 3.91vw;
    background: #fff;
    .nav-inner-pannel{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.45vw 1.56vw;
    }
    .logo{
      // width: 10.89vw;
      // width: 15.47vw;
      height: 3vw;
      img{
        // width: 100%;
        height: 100%;
      }
    }
    a{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.73vw;
      color: #222222;
      line-height: 1vw;
    }
  }
  .main{
    flex:1;
    min-height: 27vw;
    width: 100%;
    background: url(../assets/images/login_bg.gif) no-repeat top center;
    background-size: 100% auto;
    background-color: #D5E2F5;
    position: relative;
    .form-wrap{
      width: 24.756vw;
      height: 26.146vw;
      background: #fff;
      position: absolute;
      // top: 9.948vw;
      right:15vw;
      top:50%;
      margin-top: -13vw;
      .form-panel{
        padding: 1.98vw 1.56vw 0;
        .login-way-tab{
          display: flex;
          justify-content: space-between;
          line-height: 1.56vw;
          margin-bottom: 2.8125vw;
          .current-tit{
            font-family: PingFangSC-Semibold;
            font-size: 1.35vw;
            color: #333333;
          }
          .btn-tit{
            font-family: PingFangSC-Semibold;
            font-size: 1.04vw;
            color: #2D87FE;
          }
        }
        .el-form{
          .zdy-label{
            width: 4.2vw;
            border: 1px solid #dcdfe6;
            border-right: 0;
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            .zdy-label-inner{
              height: 2.7vw;
              line-height: 2.7vw;
              font-size: 0.833vw;
              font-weight: 500;
              text-align: center;
              color: #333333;
            }
          }
          .el-form-item{
            margin-bottom: 0.9375vw;
          }
          .el-form-item__error{
            font-size: 0.75vw;
          }
          .el-input__wrapper{
            border-radius: 2px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
          .el-input{
            flex: 1;
            .el-input__inner{
              height: 2.7vw;
              font-size:0.75vw;
            }
          }
          .val-code-wrap{
            display: flex;
            width: 100%;
            .el-button{
              width: 8.33vw;
              height: 2.7vw;
              line-height: 2.7vw;
              background-color: #2D87FE;
              font-size:0.75vw;
            }
          }
          .login-sub-btn{
            width: 100%;
            height: 2.813vw;
            margin-top: 2.4vw;
            margin-bottom: 1.146vw;
            background-color: #2D87FE;
            font-size: 0.83vw;
          }
        }
        .remeber-password{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.833vw;
          .el-checkbox.el-checkbox--small{
            height: 0.9375vw;
          }
          .el-checkbox.el-checkbox--small .el-checkbox__inner{
            width: 0.9375vw;
            height: 0.9375vw;
          }
          .el-checkbox.el-checkbox--small .el-checkbox__label{
            font-size: 0.73vw;
          }
          .el-checkbox__label{
            padding-left: 0.42vw;
          }
          a{
            font-family: PingFangSC-Semibold;
            color: #2D87FE;
            font-size: 0.833vw;
            text-decoration: underline;
          }
        }
      }
      .go-register-panel{
        width: 100%;
        height: 3.44vw;
        background-color: #F8F8F8;
        position: absolute;
        bottom: 0;
        div{
          padding: 0 1.56vw;
          line-height: 3.44vw;
          font-size: 0.73vw;
          a{
            color: #2D87FE;
          }
        }
      }
    }
  }
  .footer{
    position: absolute;
    bottom: 0;
    width: 100%;
    //height: 4.583vw;
    background: #fff;
    .footer-inner-pannel{
      padding: 1vw 1.56vw;
      position: relative;
    }
    // div{
    //   margin-bottom: 0.42vw;
    // }

    // div.float-r{
    //   position: absolute;
    //   right: 0;
    //   top: 1vw;
    // }
    span{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.73vw;
      color: #2E2F2F;
      line-height: 1vw;
      margin-right: 0.833vw;
    }
  }
}
.loginMobile{
  .nav,.footer{
    display: none;
  }
  .main{
    padding: 0 5.33vw;
  }
  .form-wrap{
    padding-top: 30.93vw;
    .form-panel{
      .login-way-tab{
        display: flex;
        justify-content: center;
        margin-bottom: 6.93vw;
        .current-tit{
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 5.33vw;
          div.txt{
            line-height: 6.4vw;
            margin-bottom:2.67vw;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 4.533vw;
            color: #3D7EFD;
          }
          div.line{
            width: 13.33vw;
            height: 1.1vw;
            background: #3D7EFD;
          }
        }
        a.btn-tit{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 3.73vw;
          color: #171717;
          line-height: 6.4vw;
        }
      }
      .el-form-item{
        margin-bottom: 4vw;
      }
      .el-form-item__error{
        font-size:3.733vw;
      }
      .el-input__wrapper{
        border-radius: 4px;
      }
      .el-input{
        width: 100%;
        .el-input__inner{
          height: 12.27vw;
          font-size:16px;
        }
      }
    }
    .login-sub-btn{
      width: 100%;
      height: 12.27vw;
      background: #3D7EFD;
      border-radius: 4px;
      margin-bottom: 41.87vw;
      span{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 4.27vw;
        color: #FFFFFF;
      }
    }
    .remeber-password{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5.33vw;
      .el-checkbox.el-checkbox--small{
        height: 4.8vw;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__inner{
        width: 4.8vw;
        height: 4.8vw;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__label{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 3.733vw;
        color: #979DA5;
        line-height: 5.33vw;
      }
      .el-checkbox__label{
        padding-left: 2.4vw;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #2D87FE;
        border-color: #2D87FE;
      }
    }
    .go-register-panel{
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 3.733vw;
      color: #222222;
      a{
        color: #1663FF;
      }
    }
    
    .val-code-wrap{
      position: relative;
      width: 100%;
      margin-bottom: 1.33vw;
      .el-input__inner{
        padding-right: 21.87vw;
      }
      .code-btn{
        position: absolute;
        right: 3.2vw;
        top:3.7vw;
        line-height: 5.33vw;
        cursor: pointer;
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 3.733vw;
          color: #3D7EFD;
        }
      }
    }
  }
}
</style>